import React from "react";
import { Navigate } from "react-router-dom";

import { useCurrentAdmin } from "hooks";
import { ComponentLoader } from "common/loader";

type Props = React.PropsWithChildren<unknown>;

export const AuthRoute = ({ children }: Props) => {
  const { loading, currentAdmin } = useCurrentAdmin();

  if (loading) {
    return <ComponentLoader loading />;
  }

  if (currentAdmin) {
    return <Navigate to="/" />;
  }

  return children as JSX.Element;
};

export const ProtectedRoute = ({ children }: Props) => {
  const { loading, currentAdmin } = useCurrentAdmin();

  if (loading) {
    return <ComponentLoader loading />;
  }

  if (!currentAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children as JSX.Element;
};
